import { clsx } from 'clsx';

import { type Behaviour, type Display } from '../../types';

import styles from '../../InteractiveTypography.css';

type TextBehaviourOptions = {
  behaviour: Behaviour | null;
  display: Display;
  fullWidth: boolean;
  isLink: boolean;
};

export function getTextBehaviourClassName(options: TextBehaviourOptions): string {
  const { behaviour, display, fullWidth, isLink } = options;

  let cn = styles['text'];

  switch (behaviour) {
    case 'hover_black_to_primary':
      cn = clsx(cn, styles['color-black'], styles['color-animation'], styles['hover-to-color-primary']);
      break;
    case 'hover_primary_to_primary_hover':
      cn = clsx(cn, styles['color-primary'], styles['color-animation'], styles['hover-to-color-primary-hover']);
      break;
    case 'hover_gray_to_primary':
      cn = clsx(cn, styles['color-gray'], styles['color-animation'], styles['hover-to-color-primary']);
      break;
    case 'hover_gray_to_black':
      cn = clsx(cn, styles['color-gray'], styles['color-animation'], styles['hover-to-color-black']);
      break;
    case 'static_primary':
      cn = clsx(cn, styles['color-primary']);
      break;
  }

  switch (display) {
    case 'inline-flex':
    case 'flex':
    case 'inline-block':
      cn = clsx(cn, styles[`display-${display}`]);
  }

  cn = clsx(cn, fullWidth ? styles['width-wide'] : styles['width-feet']);

  if (isLink) {
    cn = clsx(cn, styles['link']);
  }

  return cn;
}
